import { useQuery } from '@tanstack/react-query';

import { taxReturnService } from '../services/taxReturn.service';

export const useTaxReturnRecent = () => {
  return useQuery({
    queryKey: ['tax-return-recent'],
    queryFn: () => taxReturnService.listMostRecentTaxReturns()
  });
};
